import { useState } from "react";

const tenures = [12, 24, 36, 48, 60, 72, 84];

const calculateEMI = (P, annualRate, months) => {
  const r = annualRate / 12 / 100;
  return Math.round(
    (P * r * Math.pow(1 + r, months)) /
      (Math.pow(1 + r, months) - 1)
  );
};

export default function EmiCalculator({ price, onClose }) {
  const [loanAmount, setLoanAmount] = useState(price || 400000);
  const [interest, setInterest] = useState(8);

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="bg-white rounded-2xl w-full max-w-4xl p-8 relative">
        {/* CLOSE */}
        <button
          onClick={onClose}
          className="absolute top-4 right-5 text-3xl text-gray-500"
        >
          ×
        </button>

        <h2 className="text-2xl font-bold mb-6">Loan EMI Calculator</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* LEFT */}
          <div>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Looking for Car Loan? EMI calculation made easy for Car Loan.
              Just enter the Loan Amount and Interest Rate to calculate the EMI.
            </p>

            <div className="mb-4">
              <label className="block mb-1 font-medium">Loan Amount</label>
              <input
                type="number"
                value={loanAmount}
                onChange={(e) => setLoanAmount(Number(e.target.value))}
                className="w-full border rounded-md px-4 py-2 focus:outline-none"
              />
            </div>

            <div className="mb-6">
              <label className="block mb-1 font-medium">
                Rate of Interest (%)
              </label>
              <input
                type="number"
                value={interest}
                onChange={(e) => setInterest(Number(e.target.value))}
                className="w-full border rounded-md px-4 py-2 focus:outline-none"
              />
            </div>

            <button className="bg-blue-800 text-white px-6 py-3 rounded-lg w-full">
              Calculate EMI
            </button>
          </div>

          {/* RIGHT TABLE */}
          <div className="border rounded-lg overflow-hidden">
            <table className="w-full border-collapse">
              <thead className="bg-gray-400 text-white">
                <tr>
                  <th className="p-3 text-left">Months</th>
                  <th className="p-3 text-right">EMI (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                {tenures.map((m) => (
                  <tr key={m} className="border-b">
                    <td className="p-3">{m}</td>
                    <td className="p-3 text-right font-medium">
                      Rs. {calculateEMI(loanAmount, interest, m)}/-
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
